<template>
  <div class="content">
    <div class="top">
      <!-- @click="$router.push({name:'Home'})" -->
      <div class="logo page-left top-box cursor" @click="toHome">
        <!-- <img src="@/assets/redesignImg/logo_sgb-wl.png"> -->
        <img :src="require('@/assets/public/logoNew.png')" />
      </div>
      <!-- <div @click="toHome" class="laowu">
        <img src="@/assets/public/laowu.png" />
      </div> -->
      <SubmitSearch ref="searchBox"></SubmitSearch>

      <div class="post-mess">
        <el-button
          type="primary"
          @click="PublishBtns"
          class="btn-publish-info"
        >
          发布
        </el-button>
        <!-- <el-button class="btn-publish-info" @click="loginIndex" v-else>
          发 布
        </el-button> -->
      </div>
      <!-- 动图 -->
      <img class="gifimg" src="@/assets/public/daohang-gif.gif" />

      <!-- 弹窗1 个人用户未认证弹框
      <el-dialog
        center
        title="完成实名认证"
        :visible.sync="dialogFormVisible1"
        width="35%"
        :close-on-click-modal="false"
      >
        <span style="text-align: center;display: inline-block;width: 100%;">
          实名认证用户才能参与报价，是否去完成认证！
        </span>
        <div slot="footer" class="dialog-footer">
          <el-button @click="dialogFormVisible1 = false">取 消</el-button>
          <el-button type="primary" @click="DeCertification">确 认</el-button>
        </div>
      </el-dialog> -->
      <el-dialog
        title="温馨提示"
        :visible.sync="dialogFormVisible1"
        width="31%"
        :close-on-click-modal="false"
      >
        <img
          src="@/assets/home-search/tip.png"
          style="
            text-align: center;
            display: block;
            margin: 0 auto;
            margin-bottom: 19px;
          "
        />
        <span
          style="
            text-align: center;
            display: inline-block;
            width: 100%;
            font-size: 16px;
            color: #969696;
            font-weight: 400;
            font-family: Microsoft YaHei;
          "
        >
          你还未进行实名认证
        </span>
        <div
          slot="footer"
          class="dialog-footer"
          style="text-align: center; padding-bottom: 20px"
        >
          <el-button type="primary" @click="DeCertification">去认证</el-button>
        </div>
      </el-dialog>

      <!-- 弹窗2 企业用户未认证-无权限弹框-->
      <el-dialog
        center
        title="提示"
        :visible.sync="dialogFormVisible2"
        width="35%"
        :close-on-click-modal="false"
      >
        <span style="text-align: center; display: inline-block; width: 100%">
          你还没有权限哦
        </span>
        <div slot="footer" class="dialog-footer">
          <el-button type="primary" @click="dialogFormVisible2 = false">
            确 定
          </el-button>
        </div>
      </el-dialog>

      <!-- 弹框3 发布信息弹框 -->
      <el-dialog
        custom-class="publishDia"
        title="请选择发布内容"
        :visible.sync="dialogFormVisible3"
        width="785px"
        :close-on-click-modal="false"
      >
        <!-- <div class="publishDia_title">工程/工队</div> -->
        <div class="btnTop">
          <ul class="btnList">
            <li
              class="mgBox"
              v-for="(tab, index) in filtertabsGroup"
              :key="index"
              style="cursor: pointer"
              @click="handleBtn(tab.name, tab.path)"
            >
              <img :src="tab.iconUrl" alt />
              <span>{{ tab.name }}</span>
            </li>
          </ul>
        </div>     
      </el-dialog>
    </div>
  </div>
</template>
<script>
import axios from "@/http"
import { mapState } from "vuex"
import sessionStorage from "@/storage/sessionStorage"
import link from "@/public/link.js"
export default {
  name: "Search",
  data() {
    return {
      dialogFormVisible1: false, // 个人未完成认证弹框
      dialogFormVisible2: false, // 企业用户未认证-无权限弹框
      dialogFormVisible3: false, // 发布信息
      personal: process.env.VUE_APP_PERSONURL,
      restaurants: [],
      isChecked: true,
      checkedNumber: 1,
      searchText: "",
      link: link,
      tabsGroup: [
        {
          name: "工队发布",
          path: "/teamInfoList3",//企业跳转地址
          iconUrl: require("@/assets/home-search/gongduifabu.png")
        },
        {
          name: "工队发布",
          path: "/teamInfoList",//团队和个人跳转地址
          iconUrl: require("@/assets/home-search/gongduifabu.png")
        },
        {
          name: "工种报价",
          path: "/gdbjList?release=1",
          iconUrl: require("@/assets/home-search/gongzhongbaojia.png")
        },
        {
          name: "工人求职",
          path: "/needsWorkerList?release=1",
          iconUrl: require("@/assets/home-search/gongrenqiuzhi.png")
        },
        {
          name: "用工发布",
          path: "/flexWorkerList?release=1",
          iconUrl: require("@/assets/home-search/yonggongfabu.png")
        },
        {
          name: "劳务发布",
          path: "/teamLaborService",
          iconUrl: require("@/assets/home-search/laowufabu.png")
        }
      ],
    }
  },
  components: {
    SubmitSearch: () => import("@/components/public/components/SubmitSearch"),
  },
  computed: {
    ...mapState({
      userState: state => state.user
    }),
    filtertabsGroup() {
      if (this.userState != null) {
        if (this.userState.type === 0) {//个人身份
          return this.tabsGroup.filter(item => item.name != "工种报价" && item.name != "用工发布"&&item.path!='/teamInfoList3'||item.path=='/teamInfoList')
        } else if (this.userState.type === 1) {//企业身份
          return this.tabsGroup.filter(item => item.name != "工人求职"&& item.name != "工种报价"&&item.path!='/teamInfoList'||item.path=='/teamInfoList3')
        }else if(this.userState.type === 2){//团队身份
          return this.tabsGroup.filter(item => item.name != "工人求职"&& item.name != "工种报价"&&item.path!='/teamInfoList3'||item.path=='/teamInfoList')
        }
      }
    }
  },
  methods: {
    blur() {
      this.$refs.searchBox.outBlur();
    },
    PublishBtns() {
      // type 0 普通用户 1 企业用户 
      // personalAuth 个人用户的判断 0 未认证  1 已认证
      // companyAuthStatus 公司用户的判断 0 未认证 1 认证中 2 认证成功 3 认证失败
      const result =this.permissionTips({type:['person','company','team']});
      if(result) {return }
      if (this.userState === null) {
        this.loginIndex()
      }
      if (this.userState.type === 0) {
        if (this.userState.personalAuth === 0) {
          this.dialogFormVisible1 = true
        } else {
          this.dialogFormVisible3 = true
        }
      } else if (this.userState.type === 1) {
        if (this.$store.state.authorization === 1) {
          this.dialogFormVisible3 = true
        } else {
          this.dialogFormVisible2 = true
        }
      } else if(this.userState.type === 2){
         this.dialogFormVisible3 = true
      } else {
         this.$message.error('当前身份不可用，请切换至个人或者企业身份')
      }

      //  TODO: 后面暂时不用
      // relevance:true 是否关联企业
      // if (this.userState.userRole === 0) {
      //   //
      //   if (this.userState.personalAuth === 0) {
      //     this.dialogFormVisible1 = true
      //   } else {
      //     this.dialogFormVisible3 = true
      //   }
      // } else if (this.userState.userRole === 1) {
      //   //
      //   if (this.userState.companyAuthStatus === 2) {
      //     this.dialogFormVisible3 = true
      //   } else {
      //     this.dialogFormVisible2 = true
      //   }
      // }
    },
    // 个人未认证-跳转认证页面
    DeCertification() {
      const type = process.env.VUE_APP_MATERIALSURL
      if (type === "https://dev.gcw.net") {
        //
        this.dialogFormVisible1 = false
        window.open("https://user.gcw.net/authenticationRealName")
      } else {
        //
        this.dialogFormVisible1 = false
        window.open("https://user.jingyingbang.com/authenticationRealName")
      }
    },
    /** @name 发布 */
    handleBtn(name, path) {
      if(name=='工队发布'){
        const result =this.permissionTips({type:['person','company','team']});
        if(result) {return }
      } else if(name=='工人求职'){
        const result =this.permissionTips({type:['person']});
        if(result) {return }
      } else if(name=='用工发布' || name=='劳务发布'){
        const result =this.permissionTips({type:['company','team','person']});
        if(result) {return }
      } else if(name=='工种报价'){
        const result =this.permissionTips({type:['company']});
        if(result) {return }
      }
      // 没有实名
      if (this.userState.personalAuth === 0) {
        this.dialogFormVisible1 = true
      } else {
        //传递参数release=1处理跳转到用户中心对应的详情页面，在用户中心判断有无参数判断是否到详情页面
        let routeUrlU=`${this.personal}${path}`
        window.open(routeUrlU,"_blank")
      }
    },
    goHome() {
      link.index()
    },
    toHome() {
      this.$router.push("./home")
    },
    loginIndex() {
      let data = {
        callBack: function () {
          this.$store.dispatch("setUser")
          //this.pushThis()
        }.bind(this)
      }
      this.$_login(data)
    },
    initData() {},
    switchoverIsChecked(bol) {
      if (!bol) {
        this.isChecked = false
        this.checkedNumber = 2
      } else {
        this.isChecked = true
        this.checkedNumber = 1
      }
      // if(et.target.innerText=='求租') {
      //
      //   this.isChecked = false
      //   this.checkedNumber = 2
      // } else {
      //
      //   this.isChecked = true
      //   this.checkedNumber = 1
      // }
    },
    handleCommand(command) {
      if (!this.$store.state.loginType) {
        link.login()
      }
      // if (command === 'goRentPublish') {
      //   // this.$router.push({ path: `/userCenter/rentPublish` })
      // } else {
      //   // this.$router.push({ path: `/userCenter/inquiryPublish` })
      // }
    },
    searcdClick() {
      if (this.searchText === "") {
        this.$message.error("搜索不能为空")
      } else {
        let that = this
        if (this.checkedNumber === 1) {
          axios({
            method: "get",
            url:
              `/search/searchRentInfo?page=1&limit=10&words=` + that.searchText
          }).then(res => {
            sessionStorage.save(
              "storageSearchRentOut",
              JSON.stringify(res.data.data)
            )
            this.$router.push({ path: "/rentalInformationView/:id" })
            setTimeout(function () {
              window.location.reload()
            }, 100)
          })
        } else {
          axios({
            method: "get",
            url:
              `/search/searchWantedInfo?page=1&limit=10&words=` +
              that.searchText
          }).then(res => {
            sessionStorage.save(
              "storageSearchWanted",
              JSON.stringify(res.data.data)
            )
            this.$router.push({ path: "/leasedEnterprise/:id" })
            setTimeout(function () {
              window.location.reload()
            }, 100)
          })
        }
      }

      // this.$router.push({path:`rentOut`})
    },
    querySearch(queryString, cb) {
      //
      // 获取智能搜索数据
      axios({
        method: "get",
        url: `/search/keywords?page=1&limit=10&words=` + queryString
      }).then(res => {
        for (let i = 0; i < res.data.data.length; i++) {
          res.data.data[i].value = res.data.data[i].keyword
        }
        cb(res.data.data)
      })
    },
    handleSelect(item) {
      //
    },
    createFilter(queryString) {
      return restaurant => {
        return (
          restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) ===
          0
        )
      }
    }
  },
  watch: {},
  mounted() {
    this.initData()
  },
  created() {}
}
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
@import "@/styles/variable.scss";
// @media screen and (min-width: 1200px) {
//   .content {
//     .top {
//       width: 1200px;
//       .search {
//         width: 559px;
//         right: 167px;
//       }
//       .post-mess {
//         right: 0px;
//       }
//     }
//   }
// }

// @media screen and (max-width: 1200px) {
//   .content {
//     .top {
//       width: 100%;
//       .search {
//         width: 37.5%;
//         left: 40%;
//       }
//       .top-box {
//         // margin-left: 20px;
//       }
//       .post-mess {
//         right: 20px;
//       }
//     }
//   }
// }
// @media screen and (max-width: 992px) {
//   .content {
//     .top {
//       width: 992px;
//       .search {
//         width: 372px;
//         left: 397px;
//       }
//     }
//   }
// }
.btn-publish-info {
  width: 84px;
  height: 40px;
  display: block;
  // background: #c6a56f;
  background-color: #e1251b !important;
  border: none;
  color: #fff !important;
  border-radius: 4px;
  text-align: center;
  cursor: pointer;
  font-size: 16px;
}
/deep/ .publishDia {
  .el-dialog__header {
    border-bottom: 1px solid #dfe4ea;
  }
  .publishDia_title {
    height: 16px;
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #000000;
    margin-bottom: 30px;
  }
}
.content {
  padding-top: 18px;
  width: 100%;
  height: 86px;
  margin: 0 auto;
  background-color: $color-white;
  .top {
    position: relative;
    display: flex;
 	  align-items: center;
    width: 1200px;
    margin: 0 auto;
    .top-box {
      // margin-top: 6px;
      width: 238px;
      height: 70px;
      margin-right: 78px;
    }
    .laowu {
      position: absolute;
      left: 233px;
      top: 38px;
      cursor: pointer;
    }
    .gifimg {
      position: absolute;
      right: 0px;
      top:-8px
    }
    .search {
      width: 512px;
      height: 40px;
      position: absolute;
      top: 0px;
      right: 254px;
      border-radius: 6px;
      box-shadow: -3px 3px 20px 0px #e1e1e1, -3px -3px 20px 0px #e1e1e1;
      .search-tag {
        width: 66px;
        height: 25px;
        text-indent: 15px;
        line-height: 25px;
        position: absolute;
        top: -25px;
        cursor: pointer;
      }
      .rent-out {
        left: 0;
      }
      .wanted {
        left: 50px;
      }
      .checked {
        color: $color-white;
        background: url("../../../assets/public/bg_default.png");
        z-index: 1;
      }
      .no-checked {
        color: $primary-gray-dark;
        background: url("../../../assets/public/bg_gray.png");
      }
      .search-text {
        width: 100%;
        height: 40px;
        position: absolute;
        left: 0;
        border-radius: 6px;
      }
      .search-button {
        width: 84px;
        height: 40px;
        line-height: 40px;
        position: absolute;
        right: 0;
        border-radius: 0 6px 6px 0px;
        text-align: center;
        cursor: pointer;
      }
    }
    .post-mess {
      margin-right: 20px;
      height: 40px;
	    line-height: 40px;
      .warning {
        width: 156px;
        height: 40px;
        background: #f2f2f2;
        // border-color: $default;
        color: #000;
        // border-radius: 4px;
        line-height: 40px;
        text-align: center;
        cursor: pointer;
        // font-size: 18px;
      }
      // button{
      //   font-size: 18px;
      //   background-color:$default;
      //   border-color:$default;
      // }
    }
    .logo {
      img {
        width: 100%;
        height: 100%;
      }
    }
  }
  .btnTop {
    .btnList {
      justify-content: space-around;
      flex-wrap: wrap;
      align-items: center;
      text-align: left;
      .mgBox {
        display: inline-block;
        width: 149px;
        text-align: center;
      }
      img {
        display: inline-block;
        width: 56px;
        height: 56px;
      }
      span {
        display: block;
        font-size: 14px;
        height: 35px;
        line-height: 35px;
        color: rgba(51, 51, 51, 1);
      }
    }
  }
  .search-text {
    .el-input__inner {
      height: 40px;
      border: none;
      &:focus {
        outline: none !important;
        border: none;
      }
    }
  }
}
</style>
<style>
.content .search-text .el-autocomplete {
  width: 100%;
}
.content .search-text .el-autocomplete .el-input input {
  border: none;
  height: 40px;
}
.content .el-button {
  border-radius: 0;
}
</style>
